import React from 'react'

import { useDashboardFeatureFlags } from '@components'
import { Dropdown, Toasts, useModalContext } from '@fourthwall/components'
import { routing } from '@utils/routing'

import type { ConnectedShops } from '../../types'
import * as S from './ShopSwitch.styled'
import { ShopItem } from './components/ShopItem/ShopItem'
import { CreateNewSiteModalContainer } from './modules/CreateNewSiteModal'

type ShopSwitchProps = {
  connectedShops: ConnectedShops | undefined
}

export const ShopSwitch = ({ connectedShops }: ShopSwitchProps) => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { open, close } = useModalContext()

  const onCreateNewSiteClick = () =>
    open(CreateNewSiteModalContainer, {
      onSuccess: (data) => {
        close()
        Toasts.notify(`${data.name} site created successfully.`, { type: 'success' })
        window.location.assign(`${data.internalBaseUri}${routing.home}`)
      },
    })

  return (
    <>
      <S.Container>
        {connectedShops?.map(({ id, internalBaseUri, baseUri, logoUri, name, primaryDomain }) => (
          <ShopItem
            key={id}
            adminLink={`${internalBaseUri}${routing.home}`}
            shopLink={baseUri}
            label={name}
            labelDescription={primaryDomain}
            logoUrl={logoUri}
          />
        ))}
        {dashboardFeatureFlags.createNewSite.enabled && (
          <Dropdown.Item label="Create a new site" onClick={onCreateNewSiteClick} />
        )}
      </S.Container>
      <Dropdown.Divider />
    </>
  )
}
